<div class="widget">
  <i-tabler name="circle-plus"></i-tabler>
  <span>Neue Probeklausur</span>
</div>